// extracted by mini-css-extract-plugin
export var cardsWrapper = "TeamMemberCardModule-module--cardsWrapper--1iOdo";
export var headline = "TeamMemberCardModule-module--headline--HB5NS";
export var centered = "TeamMemberCardModule-module--centered--33cmD";
export var buttonDiv = "TeamMemberCardModule-module--buttonDiv--rMlyF";